<template>
  <div class="peripheralList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select
            v-model="serviceValue"
            :placeholder="$t('lang.lab_serviceType')"
          >
            <el-option
              key
              :label="$t('lang.lab_serviceType')"
              value
            ></el-option>
            <el-option
              v-for="(item,index) in serviceTypes"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="recommendValue"
            :placeholder="$t('lang.lab_recommendedStatus')"
          >
            <el-option
              key
              :label="$t('lang.lab_recommendedStatus')"
              value
            ></el-option>
            <el-option
              v-for="(item,index) in recommends"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="discountValue"
            :placeholder="$t('lang.lab_preferentialStatus')"
          >
            <el-option
              key
              :label="$t('lang.lab_preferentialStatus')"
              value
            ></el-option>
            <el-option
              v-for="(item,index) in discounts"
              :key="index"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="key"
            :placeholder="$t('lang.lab_inputNameOrTel')"
          ></el-input>
        </el-form-item>
        <el-button
          type="primary"
          @click="commit"
        >{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button
        type="primary"
        slot="header"
        @click="add"
      >{{$t('lang.btn_addPeripheral')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
      >
        <el-table-column
          type="selection"
          width="55"
          v-if="peripheralListcheckbox"
        ></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column
          prop="name"
          :label="$t('lang.lab_merchantName')"
        >
        </el-table-column>
        <el-table-column
          prop="typeName"
          :label="$t('lang.lab_serviceType')"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="phone"
          :label="$t('lang.lab_tel')"
        >
        </el-table-column>
        <el-table-column
          prop="recommend"
          :label="$t('lang.lab_recommendedStatus')"
          sortable
        >
          <template slot-scope="scope">
            <span v-if="scope.row.recommend === null">{{$t('lang.lab_normalStatus')}}</span>
            <span v-if="scope.row.recommend === 0">{{$t('lang.lab_normalStatus')}}</span>
            <span v-if="scope.row.recommend === 1">{{$t('lang.lab_recommended')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="evaluate"
          :label="$t('lang.lab_preferentialStatus')"
          sortable
        >
          <template slot-scope="scope">
            <span v-if="scope.row.preferential === null">{{$t('lang.lab_normalStatus')}}</span>
            <span v-if="scope.row.preferential === 0">{{$t('lang.lab_normalStatus')}}</span>
            <span v-if="scope.row.preferential === 1">{{$t('lang.lab_preferential')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
           :width="require('@/config/enum').opr_width2"
        >
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button
              class="orange"
              @click="deleteOne(scope.row.id)"
            >{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>
  </div>
</template>
<script>
/**
 *@ClassName:peripheralList
 *@Description:周边服务
 *@author:宋莎
 *@Copyright:格众科技
 *@date:2020-03-05
 */
import { mapGetters } from 'vuex'

export default {
  name:'/manage/main.gardenservice',
  data() {
    return {
      multipleSelection: [], // 多选框
      peripheralListcheckbox: require('@/config/enum').peripheralListcheckbox, // 是否隐藏复选框
      tableData: [], // list
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      pageCount: 0, // 总页数
      serviceTypes: [],
      serviceValue: '', // 绑定服务类型
      recommendValue: '', // 绑定推荐状态
      discountValue: '', // 绑定优惠状态
      key: '', // 检索词
      recommends: this.$i18n.t('lang.PeripheralEdit_recommends'), // 推荐状态
      discounts: this.$i18n.t('lang.PeripheralEdit_discounts') // 优惠状态
    }
  },
  created() {
    setTimeout(() => {
       window.localStorage.setItem('peripheralEditform', '')
       window.localStorage.setItem('peripheralEditsaveData', '')
    }, 200)
    this.service()
    this.getData()
  },
  activated(){
    this.service()
    this.getData()
  },
  computed: {
      ...mapGetters(['gardenId'])
    },
  methods: {
    // 周边服务-获取列表数据
    getData() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        gardenId: this.gardenId
      }
      let loading = this.$loading()
      this.$post(`/gardenservice/list`, params).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 获取服务类型
    service() {
      let loading = this.$loading()
      this.$get(`/serviceTypes`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.serviceTypes = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 新增
    add() {
      window.localStorage.setItem('peripheralEditform', '')
      window.localStorage.setItem('peripheralEditsaveData', '')
      this.$router.push({ name: 'peripheralEdit', query: { flag: false } })
    },
    // 编辑
    edit(rowData) {
      window.localStorage.setItem('peripheralEditform', '')
      window.localStorage.setItem('peripheralEditsaveData', '')
      this.$router.push({
        name: 'peripheralEdit',
        query: {
          flag: true,
          id: rowData.id,
          gardenid: this.gardenId,
          typeid: rowData.typeid,
          name: rowData.name,
          phone: rowData.phone,
          address: rowData.address,
          imgurl: rowData.imgurl,
          recommend: rowData.recommend,
          preferential: rowData.preferential,
          reverse2: rowData.reverse2,
          alleye: rowData.alleye,
          orderby: rowData.orderby,
          avatar: rowData.avatar
        }
      })
    },
    // 删除
    deleteOne(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          this.$delete(`/gardenservice/` + id).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message({
                  type: 'success',
                  message: this.$i18n.t('lang.lab_del_success')
                })
                this.commit()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        })
        .catch(() => {
          loading.close()
          this.$message({
            type: 'info',
            message: this.$i18n.t('lang.lab_del_can')
          })
        })
    },
    // 筛选
    search() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        gardenId: this.gardenId,
        typeid: this.serviceValue,
        recommend: this.recommendValue,
        preferential: this.discountValue,
        key: this.key
      }
      let loading = this.$loading()
      this.$post(`/gardenservice/list`, params).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 查询
    commit() {
      this.pageNo = 1
      this.search()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.search()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.search()
    },
    // 表格斑马
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    }
  }
}
</script>

<style lang="scss">
</style>